/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { DashboardLayout } from "../components/Dashboard";
import { requestHttp } from '../api/services-third-parties';
import { useSelector } from "react-redux";
import { UploadFile } from '../components/UploadFiles';

export const UploadFilePage = () => {
    document.body.style.background = "#FFF";
    const state = useSelector((state: any) => state.business);
    const [message, setMessage] = useState<string | null>(null);
    const [snackbarMessage, setSnackbarMessage] = useState<string>('');

    const showSnackbar = (message: string) => {
        setSnackbarMessage(message);
        setMessage(message);

        setTimeout(() => {
            setMessage('');
            setSnackbarMessage('');
        }, 3000);
    };

    const handleUpload = async (file: File) => {
        try {
            setMessage(null);
            const validExtensions = /\.json$/i;

            if (validExtensions.test(file.name)) {
                let formData: any = new FormData();
                formData.append('file', file);

                const response = await requestHttp(
                    '/withdrawals/upload/file',
                    'POST',
                    formData,
                    {
                        'api-key': state.apiKey,
                        'api-secret': state.apiSecret,
                        'Content-Type': 'multipart/form-data'
                    }
                );

                if ([200, 201, 202].includes(response.data.statusCode)) {
                    showSnackbar(response.data.message ? response.data.message : 'File upload is successful');
                } else {
                    showSnackbar(response.data.message.message);
                }
            } else {
                showSnackbar('The file format is not allowed');
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <DashboardLayout pageTitle="Process Transactions by Batch">
            {message && (
                <div className="bg-green-100 border border-green-400 px-4 py-3 rounded relative" role="alert">
                    <span className="block sm:inline">{message}</span>
                </div>
            )}
            <UploadFile handleUpload={handleUpload} />
        </DashboardLayout>
    );
};